import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../contexts/LanguageContext';
import t from '../translations';
import StarBackground from '../components/StarBackground';

export default function WelcomePage() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const tr = t[lang];

  return (
    <div
      data-testid="welcome-page"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        background: `linear-gradient(180deg, #080C1A 0%, #0A0F1E 50%, #0D1326 100%)`,
        padding: '40px 28px',
      }}
    >
      <StarBackground count={100} />

      {/* Background image overlay */}
      <div
        style={{
          position: 'absolute', inset: 0, zIndex: 0,
          backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/a18daceb-ae2c-4f94-b376-8eade8d6511f/images/2e6857a9314d6b1823365d1ab573fb902bc73583af120a7394cfcf59e8936afd.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.15,
        }}
      />

      {/* Content */}
      <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', width: '100%' }}>
        {/* Star symbol */}
        <div className="fade-in-up" style={{ fontSize: 40, color: '#C9A84C', marginBottom: 20,
          textShadow: '0 0 30px rgba(201,168,76,0.6)' }}>
          ✦
        </div>

        {/* App name */}
        <h1
          className="fade-in-up-d1"
          data-testid="app-name-heading"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 44,
            fontWeight: 700,
            color: '#F5F0E8',
            letterSpacing: '-0.01em',
            marginBottom: 12,
            lineHeight: 1.1,
          }}
        >
          {tr.appName}
        </h1>

        {/* Tagline */}
        <p
          className="fade-in-up-d2"
          style={{ fontSize: 15, color: '#8A8580', marginBottom: 64, letterSpacing: '0.04em' }}
        >
          {tr.tagline}
        </p>

        {/* Decorative divider */}
        <div className="fade-in-up-d2" style={{
          display: 'flex', alignItems: 'center', gap: 12, marginBottom: 48,
          justifyContent: 'center',
        }}>
          <div style={{ width: 50, height: 1, background: 'rgba(201,168,76,0.3)' }} />
          <span style={{ color: '#C9A84C', fontSize: 12 }}>✦</span>
          <div style={{ width: 50, height: 1, background: 'rgba(201,168,76,0.3)' }} />
        </div>

        {/* CTA */}
        <button
          data-testid="get-reading-btn"
          className="btn-primary fade-in-up-d3"
          style={{ maxWidth: 280, margin: '0 auto', display: 'block' }}
          onClick={() => navigate('/auth')}
        >
          {tr.getReading}
        </button>
      </div>

      {/* Bottom decorative stars */}
      <div style={{ position: 'absolute', bottom: 32, left: 0, right: 0,
        textAlign: 'center', color: 'rgba(201,168,76,0.3)', fontSize: 11, zIndex: 1 }}>
        ✦ &nbsp; ✦ &nbsp; ✦
      </div>
    </div>
  );
}
